// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"4bce4d62","339":"dc319559","369":"8e3e9bc7","452":"78b0fb1d","546":"a3fc8870","613":"1e4d0f73","832":"f1bbab2d","925":"070ddca6","926":"1e8a833a"}[chunkId] + ".chunk.js";
};